import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";

// Shared "confirm before applying" modal for level and skill-status changes.
export const ConfirmChangeDialog = ({ open, title, lines = [], busy, confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, onCancel, testid = "confirm-change" }) => (
  <AlertDialog open={open} onOpenChange={(v) => { if (!v && !busy) onCancel(); }}>
    <AlertDialogContent data-testid={`${testid}-dialog`} className="bg-[#0A0A0A] border-[#262626] text-white">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-1.5 text-sm text-[#D4D4D4] max-h-[50vh] overflow-y-auto" data-testid={`${testid}-summary`}>
            {lines.map((l, i) => <div key={i}>{l}</div>)}
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid={`${testid}-cancel`}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction disabled={busy} onClick={(e) => { e.preventDefault(); onConfirm(); }} data-testid={`${testid}-confirm`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
